import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Context } from './Context'
import { NavData } from '../wbstdt/Wbstdt'
import LoadingScreen from './LoadingScreen'
import arrow from '../wbstdt/imgs/arrow.svg'

export default function Nav() {

    const { lang, switchLang } = useContext(Context)
    const [loadingScreen, setLoadingScreen] = useState(false)
    const [isMobNavBarSown, setIsMobNavBarSown] = useState(false)

    useEffect(() => {
        langSwitcherStyling()
    }, [lang])

    const switchLanguage = (switchedLang) => {
        setLoadingScreen(true)
        setTimeout(() => {
            switchLang(switchedLang)
            setTimeout(() => {
                setLoadingScreen(false)
            }, 200);
        }, 200);
    }

    const langSwitcherStyling = () => {
        let langSwitcher = [...document.querySelectorAll('.lang-switch div')]
        if (lang === 'fr') {
            langSwitcher[0].classList.add('lang-switch-item-active')
            langSwitcher[1].classList.remove('lang-switch-item-active')

        }
        else {
            langSwitcher[1].classList.add('lang-switch-item-active')
            langSwitcher[0].classList.remove('lang-switch-item-active')
        }
    }

    const bringOutNavBar = () => {
        let arrow = document.querySelector('.arrow')
        let mobNavBarList = document.querySelector('.mob-navbar-navlist')

        if (!isMobNavBarSown) {
            arrow.classList.add('arrowUp')
            mobNavBarList.classList.add('mob-navbar-navlist-down')
            setIsMobNavBarSown(true)
        } else {
            arrow.classList.remove('arrowUp')
            mobNavBarList.classList.remove('mob-navbar-navlist-down')
            setIsMobNavBarSown(false)
        }
    }

    return (
        <Fragment>
            <div id="navbar" className="box-wsp-outline">
                <div className="container flex-container-scattered box-wsp navbar">
                    <div className="bg-img contained-bg logo" style={{ backgroundImage: `url(${NavData.logo})` }} onClick={() => window.location = '/'}></div>
                    <div className="flex-container-scattered navlinks">
                        <div className="flex-container-scattered wbst-navlinks desk-navbar">
                            {NavData[lang].map((item, index) => {
                                return (
                                    <div key={index}>
                                        <Link to={NavData.links[index]}>
                                            {item}
                                        </Link>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="flex-container-scattered scn-navlinks">
                            <a href="https://www.facebook.com/SafetyABS" target="_blank" rel="noopener noreferrer"><div className="bg-img contained-bg scn-navlinks-item" style={{ backgroundImage: `url(${NavData.fbIcon})` }}></div></a>
                            <a href="https://www.instagram.com/abs_safety/" target="_blank" rel="noopener noreferrer"><div className="bg-img contained-bg scn-navlinks-item" style={{ backgroundImage: `url(${NavData.igIcon})` }}></div></a>
                            <a href="https://www.linkedin.com/company/abssafety" target="_blank" rel="noopener noreferrer"><div className="bg-img contained-bg scn-navlinks-item" style={{ backgroundImage: `url(${NavData.inIcon})` }}></div></a>
                        </div>
                        <div className="flex-container-scattered lang-switch">
                            <div className="bg-img contained-bg lang-switch-item" style={{ backgroundImage: `url(${NavData.frIcon})` }} onClick={() => switchLanguage('fr')}></div>
                            <div className="bg-img contained-bg lang-switch-item" style={{ backgroundImage: `url(${NavData.engIcon})` }} onClick={() => switchLanguage('en')}></div>
                        </div>
                        <div className="mob-navbar arrow" onClick={bringOutNavBar}>
                            <img src={arrow} alt="arrow" />
                        </div>
                    </div>
                </div>
                <div className="box-wsp mob-navbar mob-navbar-navlist">
                    <div className="container">
                        <div className="container flex-container-scattered">
                            {NavData[lang].map((item, index) => {
                                return (
                                    <div key={index}>
                                        <Link to={NavData.links[index]}>
                                            {item}
                                        </Link>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            {loadingScreen && <LoadingScreen />}
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/Component/Nav.js